import React from "react";

export default function CurrentBar({ label, value, max = 100 }) {
  const safe = value ?? 0;
  const ratio = Math.min(Math.max(safe / max, 0), 1) * 100;

  // Renk skalası
  let color = "bg-emerald-500";
  if (ratio > 80) color = "bg-red-500";
  else if (ratio > 60) color = "bg-amber-400";

  return (
    <div className="flex flex-col items-center w-16">
      {/* BAR */}
      <div className="h-72 w-6 bg-slate-200 rounded-full overflow-hidden relative shadow-inner">
        <div
          className={`absolute bottom-0 w-full ${color} transition-all duration-300`}
          style={{ height: `${ratio}%` }}
        />
      </div>

      {/* LABEL */}
      <div className="mt-2 text-xs font-semibold text-slate-600">{label}</div>

      {/* VALUE */}
      <div className="text-sm font-bold text-slate-800">
        {value != null ? value.toFixed(2) : "-"}
        <span className="text-[10px] ml-0.5 text-slate-500">A</span>
      </div>
    </div>
  );
}
